import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'white',
    px: '32px',
    mx: '25px',
    my: '6px',
    minHeight: '80vh',
  },
  backContainer: {
    pt: '1px',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: 'common.grey850',
    paddingTop: '12px',
  },
  subtitle: {
    fontSize: 14,
    color: 'common.gray',
    pt: '4px',
    pb: '24px',
  },
  searchContainer: {
    mb: '3px',
  },
  borderRadiusRemove: {
    '& .MuiInputBase-root': {
      borderRadius: 0,
    },
  },
  leftList: {
    minHeight: 290,
    maxHeight: 290,
  },
  rightList: {
    minHeight: 355,
    maxHeight: 355,
  },
  buttonContainer: {
    py: '32px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  buttonSize: {
    minWidth: '160px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
